// extracted by mini-css-extract-plugin
module.exports = {"breakpoints":"\"~web/react/components/common/styles/breakpoints.css\"","large":"only screen and (min-width: 992px)","rail":"_3ZGzH","railWrapper":"_10y_j"};